/**
 * @prettier
 */

import { useTranslation } from "react-i18next";

const PortraitOrientationGate = ({ show }) => {
    const { t } = useTranslation();

    if (!show) {
        return null;
    }

    const titleId = "portrait-orientation-gate-title";
    const messageId = "portrait-orientation-gate-message";

    return (
        <div
            className="portrait-orientation-gate"
            role="status"
            aria-live="polite"
            aria-labelledby={titleId}
            aria-describedby={messageId}
        >
            <div className="portrait-orientation-gate__panel">
                <h2
                    id={titleId}
                    className="portrait-orientation-gate__title"
                >
                    {t("idpal_change_orientation")}
                </h2>
                <p
                    id={messageId}
                    className="portrait-orientation-gate__message"
                >
                    {t("idpal_change_orientation_message")}
                </p>
            </div>
        </div>
    );
};

export default PortraitOrientationGate;
